import React, { useEffect, useState } from 'react';
import { translate } from 'react-i18next';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';

// Components
import ExtComp from '../../components/external';
import CommunicationDetailsSection from './components/CommunicationDetailsSection/CommunicationDetailsSection';
import CommunicationGoalsTable from './components/CommunicationGoalsTable/CommunicationGoalsTable';
import MessagesModal from './components/MessagesModal/MessagesModal';

// Actions
import { addActiveAppointment } from 'src/views/practitioner/Appointment/reducers/actions';
import { setBackUrl, resetBackUrl } from 'src/views/practitioner/reducer/commonActions';

// Services
import { getJob, getGoals } from '../../services/jobRequests';

// Styles
import jobsStyle from '../../Jobs.style';
import s from './CommunicationJobDetails.style';


const CommunicationJobDetails = (props) => {
  const { dispatch, match: { params }, t } = props;
  const [goals, setGoals] = useState(null);
  const [job, setJob] = useState(null);
  const [openMessagesModal, setOpenMessagesModal] = useState(false);

  const jobId = params && params.jobId;

  useEffect(() => {
    if (jobId) {
      getGoals(`/communicate-jobs/${jobId}/goals`)
        .then(goals => { setGoals(goals); })
        .catch(() => { setGoals([]); });
      getJob(`/communicate-jobs/${jobId}`)
        .then(job => { setJob(job); })
        .catch(() => { setJob({}); });
    }
    dispatch(resetBackUrl());
  }, []);

  const triggerMessagesModal = () => {
    setOpenMessagesModal(!openMessagesModal);
  };

  const goToAppointmentDetails = (appoint) => {
    if (appoint && appoint.externalAppointmentId) {
      dispatch(addActiveAppointment(appoint));
      dispatch(setBackUrl());
      dispatch(push(`/practitioner/appointments/${appoint.externalAppointmentId}/appointment`));
    }
  };

  return (
    <jobsStyle.JobGeneralWrapper>

      <ExtComp.InternalHeader />

      <s.JobDetails className='jobs-content'>

        {/* ──── Title ───────────────────────────────────────────────────────────────────────────── */}
        <div className="screen-caption">
          <Link className="back-bnt" to={'/practitioner/jobs'}>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
              <g fill="none" fillRule="evenodd">
                <path d="M-4-4h24v24H-4z" />
                <path fill="#a2a4b2" fillRule="nonzero" d="M16 7H3.83l5.59-5.59L8 0 0 8l8 8 1.41-1.41L3.83 9H16z" />
              </g>
            </svg>
          </Link>
          <span className="screen-title">{t('job_details_screen_title')}</span>
        </div>


        {/* ──── Details ─────────────────────────────────────────────────────────────────────────── */}
        <CommunicationDetailsSection job={job} triggerMessagesModal={triggerMessagesModal} />

        {/* ──── Table ───────────────────────────────────────────────────────────────────────────── */}
        <CommunicationGoalsTable goals={goals} goToAppointmentDetails={goToAppointmentDetails} />

        {/* ──── Messages modal ──────────────────────────────────────────────────────────────────── */}
        <MessagesModal job={job} isOpen={openMessagesModal} onClose={triggerMessagesModal} />

      </s.JobDetails>
    </jobsStyle.JobGeneralWrapper>
  );
};

const mapStateToProps = state => ({
  commonFilters: state.practitioner.common.commonFilters,
});

export default translate()(connect(
  mapStateToProps,
)(CommunicationJobDetails));
